import DoseList from './DoseList';
import ImageList from './ImageList';
import RegistrationList from './RegistrationList';
import StructureSetList from './StructureSetList';

export default function DatasetList() {
    return (
        <>
            <ImageList />
            <StructureSetList />
            <DoseList />
            <RegistrationList />
        </>
    );
}
